import { CommonModule } from "@angular/common";
import { Component, Input, ViewEncapsulation } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { IPlatformUser } from "@nova/common-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { CommonComponent } from "../../../../lib/components/index.mjs";
import { AuthenticatedHeaderComponent } from "../../../shared/components/auth/authenticated-header/authenticated-header.component.mjs";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { BillingSidebarComponent } from "../billing-sidebar/billing-sidebar.component";

@Component({
  selector: "app-billing-layout",
  standalone: true,
  imports: [
    BillingSidebarComponent,
    RouterOutlet,
    AuthenticatedHeaderComponent,
    CommonModule,
    BlockUIModule,
  ],
  templateUrl: "./billing-layout.component.html",
  styleUrl: "./billing-layout.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class BillingLayoutComponent extends CommonComponent {
  isToggled = false;
  @Input()
  user: IPlatformUser | undefined;

  handleToggle(newState: boolean) {
    this.isToggled = newState;
  }

  constructor(private authService: AuthService, protected router: Router) {
    super();
    this.authService.user$.subscribe((user) => {
      if (user) {
        this.user = { ...user } as unknown as IPlatformUser;
      }
      else
      {
        console.log(window.location);
        if (!window.location.pathname.toLowerCase().includes("login") &&
        !window.location.pathname.toLowerCase().includes("register") &&
        !window.location.pathname.toLowerCase().includes("reset-password"))
        {
          router.navigate(["/login"]);
        }
      }
    });
  }
}
